import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import NumOfResults from './NumOfResults';
import AddFilter from '../Filter/AddFilter';
import ViewTypeSwitch from './ViewTypeSwitch';
import ColumnsSelector from '../../components/ColumnSelector';
import { ViewMode } from '../../hooks/viewMode';
import { ViewType } from '../../hooks/useViewType';
import styles from './Toolbar.styles';
import { selectViewMode, selectViewType } from '../../redux/store/ui/common';
import ExportCSV from './ExportCSV';
import { BulkActionsButton } from '../BulkActions';
import LoadingIcon from '../shared/LoadingIcon';
import { useIsRefreshing } from '../../hooks/useLoadingViewMode';
import TimelineDateControls from './TimelineDateControls';

type FilterLayoutProps = {};

const Toolbar: React.FC<FilterLayoutProps> = () => {
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  const isRefreshing = useIsRefreshing(viewMode);

  const isTimeline =
    viewMode === ViewMode.VEHICLE && viewType === ViewType.TIME_TABLE;

  return (
    <>
      <div
        className={cn('filter-wrapper', { fixed: viewType === ViewType.MAP })}
      >
        <div className="left">
          <AddFilter />
          <NumOfResults />
          {!isTimeline && <ExportCSV />}
          {isRefreshing && (
            <div className="refreshing-indicator">
              <LoadingIcon font={14} color="#0077be" />
              <span>
                <FormattedMessage id="fleetadmin.toolbar.updating" />
              </span>
            </div>
          )}
          <TimelineDateControls />
        </div>
        <div className="right">
          <BulkActionsButton />
          {/* ColumnsSelector self-guards to TABLE || TIME_TABLE; for the timeline
              it targets the separate `timeTable` column slot (does not affect the
              cars table's `car` slot). */}
          <ColumnsSelector />
          {![
            ViewMode.CARE,
            ViewMode.SHARE,
            ViewMode.BOOKING,
            ViewMode.CATEGORIES,
            ViewMode.PRICING,
            ViewMode.CIRCLE,
            ViewMode.PROFILE,
            ViewMode.USERS,
            ViewMode.ADMINS,
            ViewMode.RECEIPTS,
            ViewMode.FUEL_TRANSACTIONS,
            ViewMode.PRIVACY_POLICY,
            ViewMode.REPORTS,
          ].includes(viewMode) && <ViewTypeSwitch viewType={viewType} />}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default Toolbar;
